export enum Locale {
  zh_CN = "zh_CN",
  en_US = "en_US",
  ja_JP = "ja_JP"
}
